import { cn } from "lib/utils";

export default function MessageBanner({
  colour = "red",
  title,
  body,
  className,
  children,
  ...props
}) {
  return (
    <div
      className={cn(
        `bg-${colour}-300 bg-opacity-[0.5] flex rounded-lg w-full relative h-full overflow-hidden`,
        className
      )}
      {...props}
    >
      <div
        className={`absolute top-0 bottom-0 left-0 w-[5px] bg-${colour} shrink-0 z-10`}
      ></div>
      <div className="flex flex-col p-4">
        {title && <div className="font-semibold">{title}</div>}
        {body && <div className="text-secondary text-sm">{body}</div>}
        {children}
      </div>
    </div>
  );
}
